import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { environment } from '../../../../../../../../../environments/environment';
import { BatchPreviewApiFatoryService } from '../factory/batch-preview-api-factory.service';

@Injectable({
  providedIn: 'root',
})
export class BatchPreviewApiService extends BatchPreviewApiFatoryService {
  public postApiUrl = environment.backend_portal_url + 'api/v1/disbursements/bulk/upload';
  public validateUrl = environment.backend_portal_url + 'api/v1/disbursements/bulk/validate';
  public baseURL = environment.backend_portal_url;

  constructor(private http: HttpClient) {
    super();
  }

  postBatchPreview(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(this.postApiUrl, formData);
  }

  validateBatchPreview(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(this.validateUrl, formData).pipe(
      catchError(val => {
        return of(val);
      })
    );
  }

  checkCutOffTime() {
    const load_url = this.baseURL + 'api/v1/disbursements/cut-off-time-status?earlyCheck=true';
    return this.http.get<any>(load_url);
  }
}
